import { setProcedureCondition } from "app/store/dashboard/surgery_types_procedures/slice/surgeryProcedureSlice";
import { resolveFilterValue } from "app/store/dashboard/surgery_types_procedures/utils/filterValues";
import useActiveProcedure from "components/pages/dashboard/surgery_types_procedures/hooks/useActiveProcedure";

const useMultiSelectFilter = (filter) => {
  const { procedureFilters, dispatch } = useActiveProcedure();
  const selected = resolveFilterValue(filter, procedureFilters);
  const { options } = filter;

  const setSelected = (nextSelected) =>
    dispatch(
      setProcedureCondition({ field: filter.field, value: nextSelected })
    );

  const isChecked = (optionValue) => selected.includes(optionValue);

  const toggle = (optionValue) =>
    setSelected(
      isChecked(optionValue)
        ? selected.filter((item) => item !== optionValue)
        : [...selected, optionValue]
    );

  const allSelected =
    options.length > 0 && options.every((option) => isChecked(option.value));

  const toggleAll = () =>
    setSelected(allSelected ? [] : options.map((option) => option.value));

  return { options, selected, isChecked, toggle, allSelected, toggleAll };
};

export default useMultiSelectFilter;
